import { VList } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { paddingLeft } from '@sleepstation/style-api-helpers'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import LevelListItem from './LevelListItem'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VList).attrs({ spacing: LAYOUT_SPACING.MEDIUM })`
  ${paddingLeft(0.5)}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const LevelList = ({ items }) => (
  <Layout>
    {renderList(
      ({ range, label, level }) => (
        <LevelListItem range={range} label={label} level={level} />
      ),
      items
    )}
  </Layout>
)

LevelList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default LevelList
